import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-general-18v1',
  templateUrl: './18v1.component.html',
})
export class VbGeneral18v1Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
